import { AptunoButton } from '@aptuno/aptuno-ui';
import styled from 'styled-components';

export const CotenantRequiredWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  justify-content: center;
  ${({ isMobile }) =>
    !isMobile &&
    `
    margin: auto;
    min-height: calc(100vh - 100px);
  `};
`;

export const ShareWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  min-height: 80px;
  margin-top: 10px;
`;
export const SharingLink = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 16px;
  padding: 16px;
  background-color: #ffffff;
  height: 56px;
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 256px;
  width: 100%;
  & p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    color: #6c757d;
  }
  & svg:hover {
    cursor: pointer;
  }
`;

export const SecondaryBtn = styled(AptunoButton)<{ isMobile: boolean }>`
  max-width: 105px !important;
  ${({ isMobile }) =>
    !isMobile &&
    `
    max-width: 240px!important;
  `};
`;

export const PrimaryBtn = styled(AptunoButton)`
  max-width: 100% !important;
`;
